module.exports = __webpack_public_path__ + "img/features-img4.83eda621.png";